import focusWithin from 'ally.js/esm/style/focus-within';
import Litepicker from 'litepicker';
import debounce from 'lodash/debounce';
import {checkVerticalresize} from '../base/utils';
import Modal from './modal';

class Program {
    constructor() {
        this.$boxes = document.querySelectorAll('.program-box');
        this.$eventsWrap = document.querySelector('.program-events');
        this.$list = document.querySelector('.js-program-list');
        this.$filter = document.querySelector('.js-program-filter');

        this.$dateTrigger = document.querySelector('.js-date-trigger');
        // this.$date = document.querySelector('.tag-list');
        this.$calendarTrigger = document.querySelector('.js-calendar-trigger');

        focusWithin();
        this.init();
    }

    init() {
        this.$boxes[0].classList.add('program-box-first');

        if (this.$filter && this.$eventsWrap) {
            this.handleTags();
            this.handleCalendar();
            this.handleTimeSlot();
            this.getEvents();

            this.$eventsWrap.classList.remove('loader');
        }
    }

    getEvents() {
        // uzupelnij this.$list
    }

    /*
     * Tagi
     */
    handleTags() {
        this.$tagsTrigger = this.$filter.querySelector('.js-tag-list-trigger');
        this.$tagsWrap = this.$filter.querySelector('.program-filter-tags');
        this.$tags = this.$filter.querySelectorAll('.tag-input');
        this.$tagAll = this.$filter.querySelector('.js-tag-all');
        this.$tagsCount = this.$filter.querySelector('.js-tags-count');
        this.$tagsPopup = this.$filter.querySelector('#tags-popup');
        this.$tagsPopupContent = this.$filter.querySelector('#tags-popup-content');
        this.$tagsClear = this.$filter.querySelector('.js-tag-list-clear');

        new Modal(this.$tagsTrigger, 'tags-popup', {
            onOpen: this.showTagsPopup.bind(this),
            onClose: this.hideTagsPopup.bind(this)
        });

        this.$filter.addEventListener('click', e => {
            if (e.target.classList.contains('tag-input')) {
                this.$filter.querySelector('.js-tag-all').classList.remove('active');
                this.updateTagCount();
            } else if (e.target.classList.contains('js-tag-all')) {
                this.clearTags();
            }
        });

        this.$tagsClear.addEventListener('click', this.clearTags.bind(this));
    }

    showTagsPopup() {
        this.$tagList = this.$tagsWrap.querySelector('.tag-list');
        this.$tagListCached = this.$tagList.cloneNode(true);

        this.$tagList.classList.remove('program-filter-tags');
        this.$tagsPopupContent.insertAdjacentElement('afterbegin', this.$tagList);
    }

    updateTagCount() {
        let checked = this.$tagsWrap.querySelectorAll(':checked').length;

        this.$tagsCount.innerHTML = checked ? `(${checked})` : '';

        if (checked) {
            this.$tagsTrigger.classList.add('active');
        } else {
            this.$tagsTrigger.classList.remove('active');
        }
    }

    hideTagsPopup($trigger) {
        let applyTags = $trigger ? $trigger.dataset['apply'] : false;

        this.$tagsWrap.insertAdjacentElement('afterbegin', applyTags ? this.$tagList : this.$tagListCached);
        this.$tagsPopupContent.innerHTML = '';

        this.updateTags();
    }

    clearTags() {
        [...this.$filter.querySelectorAll('.tag-list-wrap :checked')].forEach($el => $el.checked = false);
        this.$tagsCount.innerHTML = '';
        this.$tagsTrigger.classList.remove('active');
        this.$filter.querySelector('.js-tag-all').classList.add('active');
    }

    updateTags() {
        let $selected = this.$tagsWrap.querySelectorAll(':checked');

        this.updateTagCount();

        console.info('tagi:', $selected);

        this.updateList();
    }

    /*
     * Kalendarz
     */
    handleCalendar() {
        let columns = window.innerWidth <= 768 ? 1 : 2;

        this.$calendarTrigger = this.$filter.querySelector('.js-calendar-trigger');
        // this.$mobileDateTrigger = this.$filter.querySelector('.js-date-trigger');
        this.$calendarClear = this.$filter.querySelector('.js-calendar-clear');
        this.$calendar = this.$filter.querySelector('.js-calendar');
        this.$calendarPickRange = document.querySelector('.js-calendar-preselect');

        // https://wakirin.github.io/Litepicker/#anchor-Options
        this.calendar = new Litepicker({
            element: this.$calendar,
            inlineMode: true,
            singleMode: false,
            numberOfMonths: columns,
            numberOfColumns: columns,
            moveByOneMonth: true,
            showTooltip: false,
            minDate: new Date(),
            autoApply: true,
            lang: 'pl-PL',
            buttonText: {
                apply: 'Apply',
                cancel: 'Cancel',
                previousMonth: '',
                nextMonth: ''
            },
            // lockDays: [ ['2019-01-01', '2019-01-10'], '2019-01-31' ],
            onSelect: this.resetPreselected.bind(this)
        });

        window.addEventListener('resize', debounce(this.resizeCalendar.bind(this), 100));

        new Modal(this.$calendarTrigger, 'calendar-popup', {
            onClose: this.hideCalendarPopup.bind(this)
        });

        this.$calendarClear.addEventListener('click', () => {
            this.calendar.clearSelection();
            this.range = null;
            this.updateDate();
            this.resetPreselected();
        });

        [...this.$calendarPickRange.querySelectorAll('button')].forEach($btn => {
            $btn.addEventListener('click', this.setPreselected.bind(this));
        });
    }

    resizeCalendar() {
        checkVerticalresize(this.windowWidth, () => {
            let columns = window.innerWidth <= 768 ? 1 : 2,
                date_start = this.calendar.getStartDate(),
                date_end = this.calendar.getEndDate();

            this.windowWidth = window.innerWidth;
            this.calendar.setOptions({
                numberOfMonths: columns,
                numberOfColumns: columns
            });

            this.calendar.setDateRange(date_start, date_end);
            this.calendar.gotoDate(date_start);
        });
    }

    addDaysToDate(date, offset) {
        return new Date(new Date().setDate(date.getDate() + offset));
    }

    resetPreselected() {
        let $curr = this.$calendarPickRange.querySelector('.active');

        if ($curr) $curr.classList.remove('active');
    }

    setPreselected(e) {
        let $button = e.target,
            val = $button.dataset['value'],
            today = new Date(),
            date_start, date_end;

        switch (val) {
            case 'today': {
                date_start = new Date();
                date_end = date_start;
            }
                break;
            case 'tomorrow': {
                date_start = this.addDaysToDate(today, 1);
                date_end = date_start;
            }
                break;
            case 'weekend': {
                let days_to_weekend = 6 - today.getDay(),
                    sat = this.addDaysToDate(today, days_to_weekend),
                    sun = this.addDaysToDate(sat, 1);

                date_start = sat;
                date_end = sun;
            }
                break;
            case 'week': {
                let days_to_monday = 8 - today.getDay(),
                    mon = this.addDaysToDate(today, days_to_monday),
                    sun = this.addDaysToDate(mon, 6);

                date_start = mon;
                date_end = sun;
            }
                break;
        }

        this.calendar.setDateRange(date_start, date_end);
        this.calendar.gotoDate(date_start);

        this.resetPreselected();
        $button.classList.add('active');
    }

    parseDate(date) {
        return date.toLocaleDateString('pl-PL', {month: 'short', day: 'numeric'});
    }

    hideCalendarPopup($trigger) {
        let applyDate = $trigger ? $trigger.dataset['apply'] : false;

        if (applyDate) {
            this.range = {start: this.calendar.getStartDate(), end: this.calendar.getEndDate()};
        }

        this.updateDate();
    }

    updateDate() {
        let label = '';

        if (this.range) {
            if (this.range.start.getTime() === this.range.end.getTime()) {
                label = this.parseDate(this.range.start);
            } else {
                label = `${this.parseDate(this.range.start)} &ndash; ${this.parseDate(this.range.end)}`;
            }

            this.$calendarTrigger.classList.add('active');
            // this.$mobileDateTrigger.classList.add('active');
        } else {
            label = this.$calendarTrigger.dataset['placeholder'];
            this.$calendarTrigger.classList.remove('active');
            // this.$mobileDateTrigger.classList.remove('active');
        }

        this.$calendarTrigger.innerHTML = label;
        // this.$mobileDateTrigger.innerHTML = label;

        console.log('zakres dat: ', this.range);

        this.updateList();
    }

    /*
     * Pora dnia
     */
    handleTimeSlot() {
        this.$timeslot = this.$filter.querySelector('.js-time-slot');

        this.$timeslot.addEventListener('change', () => {
            this.timeslot = this.$timeslot.value;
            console.info('pora dnia:', this.timeslot);

            let $timeslotWrap = this.$timeslot.closest('.custom-select');

            if (this.timeslot) {
                $timeslotWrap.classList.add('active');
            } else {
                $timeslotWrap.classList.remove('active');
            }

            this.updateList();
        });
    }

    /*
     * Lista wydarzeń
     */
    updateList() {
        this.toggleList();
    }

    toggleList() {
        if (this.range || this.timeslot) {
            this.$eventsWrap.classList.add('is-list');
        } else {
            this.$eventsWrap.classList.remove('is-list');
        }
    }
}

export default Program;
